import Vue from 'vue'
import Router from 'vue-router'
import Accueil from '@/pages/Accueil'
import Actu from '@/pages/Actualités'
import Espaces from '@/pages/Espaces'
import Contact from '@/pages/Contact'
import LiensUtiles from '@/pages/LiensUtiles'
import mentionsLegales from '@/pages/MentionsLegales'
import cookiePolicy from '@/pages/CookiePolicies'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'root',
      component: Accueil
    },
    {
      path: '/actu-corbet',
      name: 'Actu',
      component: Actu
    },
    {
      path: '/espaces-membres-corbet',
      name: 'Espaces',
      component: Espaces
    },
    {
      path: '/contact-corbet',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/liens-utiles',
      name: 'Liens Utiles',
      component: LiensUtiles
    },
    {
      path: '/mentions-legales',
      name: 'Mentions Légales',
      component: mentionsLegales
    },
    {
      path: '/cookie-policies',
      name: 'Cookie Policy',
      component: cookiePolicy
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js